import React from "react";
import { Col, Row } from "reactstrap";
import { Link } from "react-router-dom";

const JobAllList = ({ jobList }) => {

    return (
        <React.Fragment>
            {jobList && jobList.map((jobListDetails, key) => (
                <div className="job-box card mt-0" key={key}>
                    <div className="p-1">
                        <Row className="align-items-center">
                            <Col md={2}>
                                <div className="text-center mb-4 mb-md-0">
                                    <Link>
                                        <img
                                            src={jobListDetails.companyImg}
                                            alt=""
                                            className="img-fluid rounded-3"
                                            style={{ width: '60px', height: '60px', objectFit: 'cover' }}
                                        />
                                    </Link>
                                </div>
                            </Col>

                            <Col md={3}>
                                <div className="mb-2 mb-md-0">
                                    <h5 className="fs-18 mb-1">
                                        <Link className="text-dark">
                                            {jobListDetails.jobTitle}
                                        </Link>
                                    </h5>
                                </div>
                            </Col>

                            <Col md={2}>
                                <div className="d-flex mb-2">
                                    <div className="flex-shrink-0">
                                        <i className="mdi mdi-map-marker text-primary me-1"></i>
                                    </div>
                                    <div style={{ display: "flex", flexDirection: "row" }}>
                                        <img src={jobListDetails.countryImage} style={{ marginTop: 3 }} height="18" />
                                        <p className="text-muted mb-0" style={{ paddingLeft: 5 }}>{jobListDetails.cityName}</p>
                                    </div>
                                </div>
                            </Col>

                            <Col md={3} className="text-center">
                                <div>
                                    <p className="text-muted mb-2">
                                        {jobListDetails.salary}
                                    </p>
                                </div>
                            </Col>

                            <Col md={2} className="text-center">
                                <div>
                                    <span
                                        className={
                                            jobListDetails.fullTime === true
                                                ? "badge bg-success-subtle text-success fs-13 mt-1 mx-1"
                                                : jobListDetails.partTime === true
                                                    ? "badge bg-danger-subtle text-danger fs-13 mt-1 mx-1"
                                                    : jobListDetails.freelancer === true
                                                        ? "badge bg-primary-subtle text-primary fs-13 mt-1 mx-1"
                                                        : ""
                                        }
                                    >
                                        {jobListDetails.jobTypeText}
                                    </span>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            ))}
        </React.Fragment>
    )
}

export default JobAllList;